export const stringToBoolean = ({ value }: { value: any }): boolean => {
	if (typeof value === 'boolean') {
		return value;
	}

	return value === 'true';
};

export const stringToBooleanNullable = ({ value }: { value: any }): boolean | null => {
	if (typeof value === 'boolean') {
		return value;
	}

	return value ? (value === 'true' || value === '1') : null
};

export const stringToNumber = ({ value }: { value: any }): number => {
	if (typeof value === 'number') {
		return value;
	}

	return Number(value);
};
